export default function getScrollbarWidth()
{
	const scrollDiv = document.createElement('div');
	Object.assign(scrollDiv.style, {
		overflowY: 'scroll',
		height: '50px',
		width: '50px',
		visibility: 'hidden',
	});
	document.body.appendChild(scrollDiv);
	const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	document.body.removeChild(scrollDiv);
	
	return scrollbarWidth;
}